

import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Select, MenuItem, Button, Collapse, Card, CardContent, Checkbox, TextareaAutosize } from "@mui/material";
import {
  getCountryAssetMasterDataList,
  getFamilyAssetMasterDataList,
  getProjectByRegionId,
  getRegionByCountryId,
  getServiceTypeList,
} from "../../api/Services/masterServie";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage, Loader } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { getAssetMappingData, getUniqueAssetNamesByFamilyId, saveServiceData } from "../../api/Services/assetServices";
import { assetFamilyMaster, assetType, attachments, CountryMaster, FaultAssetMappingMaster, ProjectMaster, RegionMaster, ServiceAttachments, ServiceReportPayload } from "../../types/assetTypes";
import { IconButton, List, ListItem, ListItemText } from "@mui/material";
import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Input,
  Autocomplete,
  TextField,
} from "@mui/material";
import { DropdownChangeEvent } from "primereact/dropdown";

import dayjs from "dayjs";
import { useRef } from "react";
import Logo from "../../assets/companyLogo.png";
import ReusablePrimeReactDialog from "../../Component/Dialog/ReusablePrimeReactDialog";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import ChooseCam from "@mui/icons-material/Camera";
import "react-html5-camera-photo/build/css/index.css";
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import { base64ToFile } from "../../const/const";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { uploadFiles } from "../../api/Services/assetServices";
import { RootState } from "../../store/Reduxstore";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate } from "react-router-dom"; // Import navigate
import ImagePreview from "../../Component/ImagePreview";
interface CreateFaultProps {
  setPathname?: React.Dispatch<React.SetStateAction<string>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedData: ServiceReportPayload;
  setSelectedData: React.Dispatch<React.SetStateAction<ServiceReportPayload>>;
}



//import { assetType } from "../../types/assetTypes";

const ServicesCreatingForm: React.FC<CreateFaultProps> = ({ setOpen, selectedData, setSelectedData, setPathname }) => {
  const userDetails = useSelector((state: RootState) => state.auth)
  console.log(userDetails);
  const [formData, setFormData] = useState<FaultAssetMappingMaster>({
    serviceAssetMapId: 0,
    assetName: "",
    familyAssetId: 0,
    familyName: "",
    serviceTemplateId: 0,
    serviceTemplateName: "",
    service: "",
    currentLocationId: 0,
    countryName: "",
    regionId: 0,
    regionName: "",
    projectId: 0,
    projectName: "",
    engineHours: "",
    commonComments:  "",
  });

  const handleReset = () => {
    setFormData({
      serviceAssetMapId: 0,
      assetName: "",
      familyAssetId: 0,
      familyName: "",
      serviceTemplateId: 0,
      serviceTemplateName: "",
       currentLocationId: 0,
    countryName: "",
    regionId: 0,
    regionName: "",
    projectId: 0,
    projectName: "",
    service: "",
    engineHours: "",
    commonComments:  "",
    });
  };

  const handleCancel = () => {
    setTemplateData([]); // Hide the template box
    setFormData({
      serviceAssetMapId: 0,
      assetName: "",
      familyAssetId: 0,
      familyName: "",
      serviceTemplateId: 0,
      serviceTemplateName: "",
      currentLocationId: 0,
      countryName: "",
      regionId: 0,
      regionName: "",
      projectId: 0,
      projectName: "",
      service: "",
      engineHours: "",
    commonComments:  "",
    });
    setOpen(false);
  };


  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);

  const navigate = useNavigate(); // Initialize navigation

  

  const [familyAssetName, setFamilyAssetName] = useState<{ value: number; label: string }[]>([]);
  const [assetType, setAssetTypeList] = useState<{ value: number; label: string }[]>([]);
  const [assetName, setAssetNameList] = useState<{ value: string; label: string }[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [savedPayload, setSavedPayload] = useState<any>(null); // Store payload for later use
  const [serviceTemplateId, setServiceTemplateId] = useState<number | null>(null);
  const [serviceTemplateName, setServiceTemplateName] = useState<string | null>(null);
  const [serviceTypes, setServiceTypes] = useState<any[]>([]);
  
  
    useEffect(() => {
    const fetchServiceTypes = async () => {
      try {
        const response = await getServiceTypeList(1, PAGESEND, {});
        setServiceTypes(response.data); // assuming response.data is an array of service type objects
      } catch (error) {
        console.error("Failed to fetch service types:", error);
      }
    };
    fetchServiceTypes();
    }, []);
  



  useEffect(() => {
    if (familyAssetName.length === 0) getAssetTypeList(1,PAGESEND);
  }, [familyAssetName]);

   const [currentLocation, setCurrentLocation] = useState<
      { label: string; value: number }[]
    >([]);
  
    const [region, setRegions] = useState<
     { label: string; value: number }[]
    >([{label: "Select a region", value: 0 }]);
  
    
  
    const [project, setProjects] = useState<
      { label: string; value: string | number }[]
      >([]);
  
    useEffect(() => {
        if (currentLocation.length === 0) getCurrentLocationList(1,PAGESEND);
      }, [currentLocation]);

      const getRegionList = async (currentLocationId: number) => {
        dispatch(setLoading(true));
        try {
            const { data, status } = await getRegionByCountryId(currentLocationId);
    
            if (status.code === 200 && data?.regions?.length > 0) {
                const updatedData: { label: string; value: number }[] = data.regions.map(
                    (val: { regionId: number; regionName: string }) => ({
                        value: val.regionId, // Convert to string
                        label: val.regionName ?? "", // Ensure it's a string
                    })
                );
                updatedData.unshift({ label: "--Select--", value: 0 });
                setRegions(updatedData);
            } 
        else {
            // ✅ Set to empty array when no data or non-200 status
            setRegions([]);
            }
                  
              } catch (error: any) {
                setRegions([]);
                  CustomMessage(error?.message, "error", enqueueSnackbar);
              } finally {
            dispatch(setLoading(false));
        }
      };

  
      const getCurrentLocationList = async (page: number, rows: number) => {
        dispatch(setLoading(true));
        try {
          const { data, status } = await getCountryAssetMasterDataList(page, rows,{currentLocationId:{value:"",matchMode: "startsWith"}});
          if (status.code === 200 && data?.length > 0) {
            const updatedData = data.map((val) => ({
              value: val.currentLocationId,
              label: val.countryName,
            }));
            updatedData.unshift({ label: "--Select--", value: 0 });
        setCurrentLocation(updatedData);
        console.log("Mapped location data:", updatedData);        
        } 
        } catch (error: any) {
          CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
          dispatch(setLoading(false));
        }
      };
      
      const getProjectList = async (regionId: number) => {
        dispatch(setLoading(true));
        try {
          const { data, status } = await getProjectByRegionId(regionId);
      
         if (status.code === 200 && data.projects.length > 0) {
            const updatedData = data.projects.map((val) => ({
              value: val.projectId.toString(),
              label: val.projectName,
            }));
            updatedData.unshift({ label: "--Select--", value: "" });
            setProjects(updatedData);
          }
        else {
      setProjects([{ label: "Select Project", value: "" }]);
      setFormData((prev) => ({
        ...prev,
        // projectId: "",
        projectName: ""
      }));
    }
            
        } catch (error: any) {
          CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
          dispatch(setLoading(false));
        }
      };
      

  const getAssetTypeList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    console.log("Fetching asset types...");

    try {
      const { data, status } = await getFamilyAssetMasterDataList(page, rows, {
        familyAssetId: { value: "", matchMode: "startsWith" }
      });

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.familyAssetId,
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: 0 });

        setAssetTypeList(updatedData);
        console.log("Updated asset type list:", updatedData);

        setFamilyAssetName(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  const getAssetNameList = async (familyAssetId: number) => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId); // Log the input

    dispatch(setLoading(true));
    try {
      const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status }); // Log the API response

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        console.log("Raw assetName data:", data); // Log raw data

        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName, // Use assetName directly
            label: assetName, // Use assetName directly
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" }); // Add default option

        console.log("Processed Asset Name List:", updatedData); // Log processed data

        setAssetNameList(updatedData);
      } else {
        console.log("No asset names found or status is not 200");
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error); // Log errors
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }
  };

  const handleSelectProjectChange = (
            e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
            name: keyof ProjectMaster,
            name2: keyof ProjectMaster
          ) => {
            const updatedData: Partial<FaultAssetMappingMaster> = { ...formData};
          
            (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
            (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;   
          
            setFormData(updatedData as FaultAssetMappingMaster);     
           
            
      };
  
      const handleSelectCountryChange = (
            e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
            name: keyof CountryMaster,
            name2: keyof CountryMaster
          ) => {
            const updatedData: Partial<FaultAssetMappingMaster> = { ...formData};
          
            (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
            (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;
      
          
            setFormData(updatedData as FaultAssetMappingMaster);
            getRegionList((e.target as { value: { value: number } }).value?.value || 0);  
      };
  
      const handleSelectRegionChange = (
            e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
            name: keyof RegionMaster,
            name2: keyof RegionMaster
          ) => {
            const updatedData: Partial<FaultAssetMappingMaster> = { ...formData};
          
            (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
            (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;
      
          
            setFormData(updatedData as FaultAssetMappingMaster);
            getProjectList((e.target as { value: { value: number } }).value?.value || 0);  
      };
  



  //const [templateData, setTemplateData] = useState<{ templateColumnName: string; checked: boolean; text: string }[]>([]);
  const [templateData, setTemplateData] = useState<{
    templateColumnId: number;
    templateColumnName: string;
    checked: boolean;
    text: string;
    attachments: attachments[];
    serviceAttachments: ServiceAttachments[];
  }[]>([]);

  console.log("Td:", templateData);

  const handleSubmit = async (e: any) => {
    e?.preventDefault();
    const updatedData = { ...formData };

    if (
      !updatedData.assetName ||
      !updatedData.familyAssetId ||
      !updatedData.familyName ||
      !updatedData.service ||
      !updatedData.currentLocationId ||
      !updatedData.countryName ||
      !updatedData.regionId ||
      !updatedData.regionName ||
      !updatedData.projectId ||
      !updatedData.projectName ||
      !selectedDate
      // Assuming serviceDate exists in formData
    ) {
      CustomMessage(
        "Please make sure to select all the details.",
        "error",
        enqueueSnackbar
      );
      return;
    }


    const payload = {
      serviceAssetMapId: 0,
      assetName: updatedData.assetName,
      familyAssetId: updatedData.familyAssetId,
      familyName: updatedData.familyName,
      service: updatedData.service,
      serviceTemplateId: 0,
      serviceTemplateName: "",
      currentLocationId: updatedData.currentLocationId,
      countryName: updatedData.countryName,
      regionId: updatedData.regionId,
      regionName: updatedData.regionName,
      projectId: updatedData.projectId,
      projectName: updatedData.projectName,
      engineHours: updatedData.engineHours,
      commonComments:  updatedData.commonComments,
      
    };

    setSavedPayload(payload); // Save payload for further use

    // Log familyAssetId and familyName
    const { assetName, familyAssetId, familyName } = payload; // Extract from the current payload
    console.log("Family Asset ID:", familyAssetId);
    console.log("Family Asset Name:", familyName);
    console.log("Asset Name:", assetName);

    dispatch(setLoading(true));

    try {
      const response = await getAssetMappingData(payload);

      console.log("Response:", response);
      console.log("Response Status:", response.status);

      if (response.status.code === 201 || response.status.code === 200) {
        //CustomMessage(response.status.message, "success", enqueueSnackbar);

        if (response.data?.serviceTemplateId && response.data?.serviceTemplateName) {
          setServiceTemplateId(response.data.serviceTemplateId);
          setServiceTemplateName(response.data.serviceTemplateName);
        }

        if (response.data?.templateColumns?.length) {
        console.log("Found Template Columns:", response.data.templateColumns);
        setTemplateData(
          response.data.templateColumns.map((col: any) => ({
            templateColumnId: col.templateColumnId,
            templateColumnName: col.templateColumnName,
            checked: false,
            text: "",
            attachments: col.attachments || []
          }))
        );
        } else {
          // 🆕 Clear old data and show message
          setTemplateData([]); 
          CustomMessage(
            "No columns are allotted to the service you are performing.",
            "info",
            enqueueSnackbar
          );
        }

      } else {
        CustomMessage(response.status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  console.log("Td:", templateData);

  console.log("Saved Payload:", savedPayload);

  const handleSave = async () => {
    const payload = {
      serviceReportingId: 0,
      user_id: userDetails.userId,
      date: selectedDate ? new Date(selectedDate) : new Date(), // Convert to Date\
      familyAssetId: savedPayload.familyAssetId,
      name: savedPayload.name,
      familyName: savedPayload.familyName,
      assetName: savedPayload.assetName,
      serviceTemplateId: serviceTemplateId !== null ? serviceTemplateId : 0,
      serviceTemplateName: serviceTemplateName !== null ? serviceTemplateName : "",
      service: savedPayload.service,
      currentLocationId: savedPayload.currentLocationId,
      countryName: savedPayload.countryName,
      regionId: savedPayload.regionId,
      regionName: savedPayload.regionName,
      projectId: savedPayload.projectId,
      projectName: savedPayload.projectName,
      engineHours: savedPayload.engineHours,
      commonComments: savedPayload.commonComments,
      serviceName: savedPayload.serviceName,
      // Ensure serviceTemplateId is included
      details: templateData.map(item => ({
        templateColumnId: item.templateColumnId ?? 0,  // Ensure templateColumnId is always present
        isChecked: item.checked, // Checkbox value
        commands: item.text || null, // Text field value
        serviceAttachments: (item.serviceAttachments || []).map((att) => ({
            serviceAttachmentId: att.attachmentId, 
            attachmentId: att.attachmentId, // Must be available after upload
            name: att.name,
            savedAttachmentName: att.savedAttachmentName, // Must be set after upload
          })),
    })),
    };

    console.log("Saving Data:", payload);

    try {
      const response = await saveServiceData(payload);

      console.log("Response:", response);

      const responseCode = response?.status?.code ?? response?.status;

      if (responseCode === 201 || responseCode === 200) {
        CustomMessage(response.status.message, "success", enqueueSnackbar);

        if (response.data?.templateColumns?.length) {
          setTemplateData(
            response.data.templateColumns.map((col: any) => ({
              templateColumnId: col.templateColumnId, // Include templateColumnId
              templateColumnName: col.templateColumnName,
              checked: false,
              attachments: [],
              text: "",
            }))
          );
        }
        setOpen(false);
      } else {
        CustomMessage(response.status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      console.error("Error saving service report:", error);
      CustomMessage(error?.message || "Failed to save", "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const handleCheckboxChange = (templateColumnId: number) => {
    setTemplateData((prev) =>
      prev.map((item) =>
        item.templateColumnId === templateColumnId
          ? { ...item, checked: !item.checked }
          : item
      )
    );
  };


  const handleTextChange = (templateColumnId: number, value: string) => {
    setTemplateData(prevData =>
      prevData.map(item =>
        item.templateColumnId === templateColumnId ? { ...item, text: value } : item
      )
    );
  };


  const handleServiceDateSelect = (date: Date | null | undefined) => {
    setSelectedDate(date ?? null); // Convert undefined to null
    console.log("Selected Service Date:", date ? date.toLocaleDateString() : "None");
    if (!date) {
      CustomMessage("Please select a date", "warning", enqueueSnackbar); // ✅ Fixed missing arguments
    }
  };







  const handleSaveDraft = () => {
    console.log("Saving draft:", formData, templateData);
  };

  const handleSelectAssetTypeChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof assetFamilyMaster,
    name2: keyof assetFamilyMaster
  ) => {
    const updatedData: Partial<FaultAssetMappingMaster> = { ...formData }; // Ensure all required fields are included

    (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;
    updatedData.assetName = "";

    setFormData(updatedData as FaultAssetMappingMaster);

    // ✅ Ensure `getAssetNameList` doesn't require an argument
    getAssetNameList((e.target as { value: { value: number } }).value?.value || 0)
  };
  const handleSelectAssetNameChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof assetType,
    name2: keyof assetType
  ) => {
    const updatedData: Partial<FaultAssetMappingMaster> = { ...formData }; // Ensure all required fields are included

    (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

    setFormData(updatedData as FaultAssetMappingMaster);
  };

  const allowedImageTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];

const handleFileUpload = async (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  templateColumnId: number
) => {
  if (!(event.target instanceof HTMLInputElement)) return;

  const fileList = event.target.files;
  if (!fileList || fileList.length === 0) {
    CustomMessage("No file selected", "error", enqueueSnackbar);
    return;
  }

  const fileArray = Array.from(fileList);

  // ✅ Image type validation
  const invalidFile = fileArray.find(file => !allowedImageTypes.includes(file.type));
  if (invalidFile) {
    CustomMessage(
      `Only image files (JPEG, PNG, JPG, WEBP) are allowed. "${invalidFile.name}" is not valid.`,
      "error",
      enqueueSnackbar
    );
    return;
  }

  dispatch(setLoading(true));

  try {
    const uploadPromises = fileArray.map(async (file) => {
      const data = new FormData();
      data.append("file", file);

      const response = await uploadFiles(data);

      if (response.status.code === 201) {
        const uploaded = response.data;

        const newAttachment: ServiceAttachments = {
          attachmentId: uploaded.attachmentId,
          serviceAttachmentId: uploaded.attachmentId,
          name: uploaded.name,
          savedAttachmentName: uploaded.savedAttachmentName,
        };

        return newAttachment;
      } else {
        throw new Error(`Upload failed with status: ${response.status.code}`);
      }
    });

    const uploadedFiles: ServiceAttachments[] = await Promise.all(uploadPromises);

    setTemplateData((prev) =>
      prev.map((item) =>
        item.templateColumnId === templateColumnId
          ? {
              ...item,
              serviceAttachments: [
                ...(item.serviceAttachments || []),
                ...uploadedFiles,
              ],
            }
          : item
      )
    );

    CustomMessage("Image(s) uploaded successfully", "success", enqueueSnackbar);
  } catch (error: any) {
    console.error("Upload error", error);
    CustomMessage(`File upload error: ${error.message}`, "error", enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
  };


const removeFile = (templateColumnId: number, serviceAttachmentId: number) => {
setTemplateData((prev) =>
  prev.map((item) =>
    item.templateColumnId === templateColumnId
      ? {
          ...item,
          serviceAttachments: item.serviceAttachments.filter(
            (att) => att.serviceAttachmentId !== serviceAttachmentId
          ),
        }
      : item
    )
  );
};



  return (
    <div>
      <Typography variant="h6" style={styles.heading}>
        Create Service
      </Typography>
      <div style={styles.container}>
        <form
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault(); // 🔒 prevent form submission
            }
          }}
        >

          <Grid container spacing={2} justifyContent="" alignItems="center" style={{ width: '100%' }}>

            {/* Asset Type */}
            <Grid item xs={3}>
              <Typography style={styless.label}>Asset Type</Typography>
              <FormControl fullWidth variant="outlined" style={styless.input}>
                <Select
                  value={formData.familyAssetId || ''}
                  onChange={(e) => {
                    const selectedOption = familyAssetName.find(option => option.value === e.target.value);
                    handleSelectAssetTypeChange({ target: { value: selectedOption || null } }, 'familyName', 'familyAssetId');
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select an Asset Type</MenuItem>
                  {familyAssetName.map((type) => (
                    <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Asset Name */}
            <Grid item xs={3}>
              <Typography style={styless.label}>Asset Name</Typography>
              <FormControl fullWidth variant="outlined" style={styless.input}>
                <Select
                  value={formData.assetName || ''}
                  onChange={(e) => {
                    const selectedOption = assetName.find(option => option.value === e.target.value);
                    handleSelectAssetNameChange({ target: { value: selectedOption || null } }, 'assetName', 'assetName');
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select an Asset Name</MenuItem>
                  {assetName.map((type) => (
                    <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
         
             <Grid item xs={3}>
              <Typography style={styless.label}>Current Location</Typography>
              <FormControl fullWidth variant="outlined" style={styless.input}>
                <Select
                  value={formData.currentLocationId || ''}
                  onChange={(e) => {
                    const selectedOption = currentLocation.find(option => option.value === e.target.value);
                    handleSelectCountryChange({ target: { value: selectedOption || null } }, 'countryName', 'currentLocationId');
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select a Current Location</MenuItem>
                  {currentLocation.map((location) => (
                    <MenuItem key={location.value} value={location.value}>{location.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <Typography style={styless.label}>Region</Typography>
              <FormControl fullWidth variant="outlined" style={styless.input}>
                <Select
                  value={formData.regionId || ''}
                  onChange={(e) => {
                    const selectedOption = region.find(option => option.value === e.target.value);
                    handleSelectRegionChange({ target: { value: selectedOption || null } }, 'regionName', 'regionId');
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select a Region</MenuItem>
                  {region.map((reg) => (
                    <MenuItem key={reg.value} value={reg.value}>{reg.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <Typography style={styless.label}>Project</Typography>
              <FormControl fullWidth variant="outlined" style={styless.input}>
                <Select
                  value={formData.projectId || ''}
                  onChange={(e) => {
                    const selectedOption = project.find(option => option.value === e.target.value);
                    handleSelectProjectChange({ target: { value: selectedOption || null } }, 'projectName', 'projectId');
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select a Project</MenuItem>
                  {project.map((proj) => (
                    <MenuItem key={proj.value} value={proj.value}>{proj.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* Service Selection */}
            <Grid item xs={3}>
              <Typography style={styless.label}>Service</Typography>
              <FormControl fullWidth variant="outlined" style={styless.input}>
                <Select
                  value={formData.service || ''}
                  onChange={(e) =>
                    setFormData({ ...formData, service: e.target.value }) // this will be the serviceTypeId
                  }
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select an Service</MenuItem>

                  {serviceTypes.map((type) => (
                    <MenuItem key={type.serviceTypeId} value={type.serviceTypeId}>
                      {type.serviceTypeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Service Date */}
            <Grid item xs={3}>
              <Typography style={styless.label}>Service Date</Typography>
              <FormControl fullWidth variant="outlined" style={styless.input}>
                <Calendar
                  id="serviceDate"
                  value={selectedDate ? new Date(selectedDate) : null}
                  onChange={(e) => handleServiceDateSelect(e.value)}
                  showIcon
                  className="h-45 bg-white"
                  dateFormat="mm/dd/yy"
                  placeholder="Service Date"
                />
              </FormControl>
            </Grid>

      <Grid item xs={3}>
  <Typography style={styless.label}>Engine Hours</Typography>
  <FormControl fullWidth variant="outlined" style={styless.input}>
    <input
      type="number"
      value={formData.engineHours === null || formData.engineHours === undefined ? "" : formData.engineHours}
      onChange={(e) =>
        setFormData({
          ...formData,
          engineHours: e.target.value,
        })
      }
      placeholder="Enter Engine Hours"
      style={{
        width: "100%",
        height: "45px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        padding: "10px",
      }}
    />
  </FormControl>
</Grid>


         <Grid item xs={12} sm={6} md={3}>
          <h6>Comments</h6>
          <TextareaAutosize
            minRows={3}
            placeholder="Write your comments here..."
            value={formData.commonComments || ""}
            onChange={(e) =>
              setFormData({ ...formData, commonComments: e.target.value })
            }
            style={{
              width: "100%",
              borderRadius: "6px",
              border: "1px solid #ccc",
              padding: "10px",
              fontFamily: "inherit",
              fontSize: "14px",
              resize: "vertical", // expandable like first UI
            }}
          />
        </Grid>




            {/* Submit Button */}
            <Grid item xs={12} style={{ display: "flex", justifyContent: "end" }}>

              <Button className="btn btn-secondary text-white" variant="outlined" color="secondary" type="submit" onClick={handleCancel} style={styless.button}>
                Cancel
              </Button>
              <Button className="btn btn-primary" variant="contained" color="primary" style={styless.button} onClick={handleSubmit}>
                Submit
              </Button>
            </Grid>

          </Grid>
        </form>

                {templateData.length > 0 && (
                  <Card style={{
                    marginTop: "30px", padding: "20px", maxWidth: "800px", // Set a maximum width
                    marginLeft: "auto",
                    marginRight: "auto"
                  }}>
                    <Typography variant="h5" style={{ marginBottom: "10px" }}>
        
                    </Typography>
        
                    <Grid container spacing={2}>
                      {templateData.map((item) => (
                        <Grid
                          item
                          xs={12}
                          key={item.templateColumnId}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px",
                          }}
                        >
                          <div
          style={{
            width: "59px",
            height: "59px",
            borderRadius: "50%",
            border: "1px solid #ccc",
            overflow: "hidden",
            backgroundColor: "#f5f5f5", // Light gray background if image is not present
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {item.attachments &&
          item.attachments.length > 0 &&
          item.attachments[0].attachmentId ? (
            <ImagePreview
              alt={`Attachment ${item.attachments[0].attachmentId}`}
              src={`${FILE_DOWNLOAD_PREVIEW}${item.attachments[0].attachmentId}`}
              style={{
                width: "59px",
                height: "59px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            // Optional: You can replace with initials, icon, or leave blank
            <span style={{ color: "#999", fontSize: "12px" }}></span>
          )}
        </div>
        
        
                          <Typography style={{ width: "300px" }}>
                            {item.templateColumnName}
                          </Typography>
        
                          <Checkbox
                            checked={item.checked}
                            onChange={() => handleCheckboxChange(item.templateColumnId)}
                          />
        
                          <TextField
                            value={item.text}
                            onChange={(e) =>
                              handleTextChange(item.templateColumnId, e.target.value)
                            }
                            placeholder="Commands"
                            variant="outlined"
                            size="small"
                            style={{ width: "300px" }}
                          />
        
                          {/* 👉 Attach file next to Commands */}
                            <Grid item>
                            <FormControl>
                              <Input
                                id={`fileUpload-${item.templateColumnId}`}
                                type="file"
                                inputProps={{ multiple: true, accept: "image/*" }} // Accept only image files
                                onChange={(e) => handleFileUpload(e, item.templateColumnId)}
                                style={{ fontSize: "14px", width: "200px" }}
                              />
                            </FormControl>
                          </Grid>
                          
                          
                            {/* 👉 Uploaded file names and actions */}
                            {item.serviceAttachments && item.serviceAttachments.length > 0 && (
                            <List
                              dense
                              sx={{
                                bgcolor: "background.paper",
                                maxHeight: 200,
                                overflowY: "auto",
                                width: "auto",
                                p: 1,
                                border: "1px solid #eee",
                                borderRadius: 2,
                                flexShrink: 0,
                              }}
                            >
                              {item.serviceAttachments.map((file) => {
                                const fileUrl = `${FILE_DOWNLOAD_PREVIEW}${file.attachmentId}`;
                          
                                return (
                                  <ListItem
                                    key={file.serviceAttachmentId}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      p: 0.5,
                                    }}
                                  >
                                    {/* Image Preview */}
                                    <Box sx={{ width: 59, height: 59, flexShrink: 0 }}>
                                      <ImagePreview
                                        src={fileUrl}
                                        alt={file?.name || "Image Preview"}
                                        style={{
                                          width: "59px",
                                          height: "59px",
                                          borderRadius: "50%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>
                          
                                    {/* File Name + Download/Delete */}
                                    <Box display="flex" flexDirection="column" gap={0.5}>
                                      <Typography variant="body2" noWrap sx={{ maxWidth: 120 }}>
                                        {file.name}
                                      </Typography>
                          
                                      <Box display="flex" gap={1}>
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            const link = document.createElement("a");
                                            link.href = fileUrl;
                                            link.setAttribute("download", file.name || "image");
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                          }}
                                        >
                                          <DownloadIcon fontSize="small" color="primary" />
                                        </IconButton>
                          
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            removeFile(item.templateColumnId, file.serviceAttachmentId)
                                          }
                                        >
                                          <CloseIcon fontSize="small" color="error" />
                                        </IconButton>
                                      </Box>
                                    </Box>
                                  </ListItem>
                                );
                              })}
                            </List>
                          )}
                          
                          </Grid>
                          
                                  
                      ))}
                    </Grid>
        
                    <Grid container spacing={2} justifyContent="center" style={{ marginTop: "20px" }}>
                      <Grid item>
                        <Button variant="contained" color="primary" type="button" onClick={handleSave}>
                          Save
                        </Button>
        
                      </Grid>
                      <Grid item>
                      </Grid>
                    </Grid>
                  </Card>
                )}

      </div>
      
    </div>

  )
};


const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: "",
    width: "100%",
    margin: "",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
  },
  heading: {
    textAlign: "left",
    color: "#333",
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
    width: "100%",
  },
  label: {
    fontSize: "16px",
    fontWeight: "bold",
    display: "block",
    marginBottom: "5px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
};

const styless = {
  label: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '5px',
  },
  input: {
    background: '#fff',
    borderRadius: '5px',
    height: '40px',
  },
  button: {
    minWidth: '120px',
    maxWidth: '120px',
    height: '40px',
    padding: '5px 12px !important',
    fontSize: '0.85rem !important',
    marginRight: '5px'
  }
};


export default ServicesCreatingForm;



